import { createSelector } from 'reselect';
import { getUsersState } from 'src/modules/users/selectors/getUsersState';

export const getUsersQuery = createSelector([
  getUsersState,
], (state) => state.query);
